export default "__VITE_ASSET__2e2000ab__"